import axios from "axios";

const api = axios.create({
  //baseURL: "https://69tde4rlpi.execute-api.us-east-1.amazonaws.com/",
  baseURL:  process.env.REACT_APP_API_BASE_URL ||  "http://localhost:4000",


  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to modify request headers
api.interceptors.request.use((config) => {
  // If the request contains a FormData object, the content type is set to 'multipart/form-data'.
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else {
    //  Otherwise, the content type is set to 'application/json'
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

// Interceptor to validate response status
api.interceptors.response.use(
  (response) => {
    // You can add your status validation logic here.
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      throw new Error("Invalid response status");
    }
  },
  (error) => {
    // Handle request errors here, for example, network errors or timeouts.
    return Promise.reject(error);
  }
);

export default api;
